import { Grid } from "@mui/material";
import StreamCards from "../../Components/Stream/StreamCards";
import { selectedStreamState, popupState, authState } from "../../Recoil/RecoilState";
import { useRecoilValue, useSetRecoilState } from "recoil";
import ParamStream from "../../Components/Stream/PramStream";
import DesBtn from "../../Components/Reusable/DesBtn";
import { useState } from "react";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import axios from "axios";
import { baseURL } from "../../utils/StaticVariables";

const ShowStream = () => {
  const selectedData = useRecoilValue(selectedStreamState);
  const setPopup = useSetRecoilState(popupState);

  const [forceStart, setForceStart] = useState(false);
  const [forceStop, setForceStop] = useState(false);
  const [loading, setLoading] = useState(false);
  const { token } = useRecoilValue(authState);
  // ▶️ Start All
  const handleStartAll = async () => {
    try {
      setLoading(true);
      await axios.post(`${baseURL}batch/start`, { stream_ids: selectedData.map((el) => el.id)}, {
        headers: { Authorization: `Bearer ${token}` },
    
      });
      setForceStart(true);
      setForceStop(false);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // ⏹️ Stop All (Popup)
  const handleStopAll = () => {
    setPopup({
      isOpen: true,
      title: "Stop All Streams",
      content: (
        <div>
          <h3>Are you sure you want to stop all streams?</h3>
          <p>
            All cameras will stop streaming and no data will be received until
            you start again.
          </p>
        </div>
      ),
      sendReq: async () => {
        try {
          setLoading(true);
          await axios.post(`${baseURL}batch/stop`, { stream_ids: selectedData.map((el) => el.id)}, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setForceStop(true);
          setForceStart(false);
        } catch (err) {
          console.error(err);
        } finally {
          setLoading(false);
        }
      },
    });
  };

  return (
    <div>
      <ParamStream />

      {/* Controls */}
      <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
        <DesBtn
          text="Start All"
          handle={handleStartAll}
          disabled={loading}
        >
          <PlayCircleFilledIcon />
        </DesBtn>

        <DesBtn
          text="Stop All"
          handle={handleStopAll}
          close
          disabled={loading}
        >
          <PauseCircleIcon />
        </DesBtn>
      </div>

      {/* Streams */}
      <Grid container spacing={2} mt={2}>
        {selectedData?.map((el) => (
          <Grid item key={el.id} xs={12} sm={6} lg={4}>
            <StreamCards
              data={el}
              forceStart={forceStart}
              forceStop={forceStop}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ShowStream;
